var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('main', {
    staticClass: "main page_students_create"
  }, [_c('h1', {
    staticClass: "title--page"
  }, [_vm._v("出欠席" + _vm._s(_vm.$route.params.id ? "更新" : "登録"))]), _vm.isLoading.getData ? _c('loading-message') : _vm._e(), _vm.isLoading.postData ? _c('loading-message', {
    attrs: {
      "loading-message": "出欠席データを登録しています"
    }
  }) : _c('div', [_c('div', {
    staticClass: "common_form"
  }, [_c('row-item', [_c('p', {
    staticClass: "col_2"
  }, [_vm._v("クラス")]), _c('p', {
    staticClass: "col_10"
  }, [_vm._v(" " + _vm._s(_vm.student.classroom.name) + " ")])]), _c('row-item', [_c('p', {
    staticClass: "col_2"
  }, [_vm._v(" " + _vm._s(_vm.studentAddress) + " ")]), _c('p', {
    staticClass: "col_10"
  }, [_vm._v(" " + _vm._s(_vm.student.name) + " ")])]), _c('AttendanceSelection', {
    attrs: {
      "type": _vm.type
    },
    on: {
      "setType": _vm.setType,
      "resetType": _vm.resetType
    }
  }), _c('row-item', [_c('p', {
    staticClass: "col_2"
  }, [_vm._v("日付")]), _c('div', {
    staticClass: "col_10"
  }, [_c('VueCtkDateTimePicker', {
    attrs: {
      "label": "日付を選択",
      "no-button-now": "",
      "only-date": "",
      "locale": "ja",
      "formatted": "LL",
      "output-format": "YYYY-MM-DD"
    },
    model: {
      value: _vm.date,
      callback: function ($$v) {
        _vm.date = $$v;
      },
      expression: "date"
    }
  })], 1)]), _vm.guardian_memo ? _c('row-item', [_c('p', {
    staticClass: "col_2"
  }, [_vm._v("詳細")]), _c('div', {
    staticClass: "col_10"
  }, [_vm._v(" " + _vm._s(_vm.guardian_memo) + " ")])]) : _vm._e(), _c('row-item', [_c('p', {
    staticClass: "col_2"
  }, [_vm._v("集計区分")]), _c('div', {
    staticClass: "col_4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.countingType,
      expression: "countingType"
    }],
    staticClass: "common_form--select",
    attrs: {
      "name": "classroom"
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.countingType = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }), _vm._l(_vm.attendanceBookCountingTypes, function (t, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": t.id
      }
    }, [_vm._v(" " + _vm._s(t.label) + " ")]);
  })], 2)])]), _c('row-item', [_c('p', {
    staticClass: "col_2"
  }, [_vm._v("先生用メモ欄")]), _c('div', {
    staticClass: "col_10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.comment,
      expression: "comment"
    }],
    staticClass: "common_form--textarea",
    attrs: {
      "name": "",
      "rows": "3"
    },
    domProps: {
      "value": _vm.comment
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.comment = $event.target.value;
      }
    }
  })])]), _c('section', {
    staticClass: "tac"
  }, [_c('input', {
    staticClass: "cancel_button",
    attrs: {
      "type": "button",
      "value": "キャンセル"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.go(-1);
      }
    }
  }), _c('input', {
    staticClass: "entry_button",
    attrs: {
      "type": "button",
      "value": (_vm.$route.params.id ? '更新' : '登録') + 'する'
    },
    on: {
      "click": _vm.saveData
    }
  })])], 1), _vm.showModal ? _c('message-modal', {
    on: {
      "close": _vm.completeCreate
    }
  }) : _vm._e()], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };